var FcCompanyOutlinedSelectModule = /** @class */ (function () {
    function FcCompanyOutlinedSelectModule() {
    }
    return FcCompanyOutlinedSelectModule;
}());
export { FcCompanyOutlinedSelectModule };
